class LocaleStorageService {
  static set = (key, value) => {
    localStorage.setItem(key, value);
  };

  static get = (key) => {
    try {
      const data = localStorage.getItem(key);
      return data;
    } catch (e) {
      return undefined;
    }
  };

  static getAll = () => {
    let data = {};

    for (let index = 0; index < localStorage.length; index++) {
      const key = localStorage.key(index);
      data[key] = localStorage.get(key);
    }

    return data;
  };

  static remove = (key) => {
    try {
      localStorage.removeItem(key);
      return true;
    } catch (e) {
      return false;
    }
  };

  static clear = () => {
    try {
      localStorage.clear();
    } catch (e) {
      return false;
    }
  };
}

export default LocaleStorageService;
